// extracted by mini-css-extract-plugin
export default {"root":"root--yHpPB","color":"color--Xforu","flex":"flex--naBsF","container":"container--Ft7QH"};